import React, { useState } from 'react';
import { motion } from 'framer-motion';

const AnimatedIcon = ({ icon: Icon, color = '#00BCD4', size = 24, className = '' }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <motion.div
      className={`relative inline-flex items-center justify-center ${className}`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.95 }}
    >
      {/* Glow effect */}
      <motion.div
        className="absolute inset-0 rounded-full blur-xl"
        style={{ backgroundColor: color }}
        initial={{ opacity: 0 }}
        animate={{ opacity: isHovered ? 0.4 : 0 }}
        transition={{ duration: 0.3 }}
      />
      
      {/* Pulse ring */}
      <motion.div
        className="absolute inset-0 rounded-full border-2"
        style={{ borderColor: color }}
        initial={{ scale: 1, opacity: 0 }}
        animate={isHovered ? {
          scale: [1, 1.5, 2],
          opacity: [0.5, 0.3, 0],
        } : { scale: 1, opacity: 0 }}
        transition={{ duration: 1, repeat: isHovered ? Infinity : 0 }}
      />

      {/* Icon */}
      <motion.div
        animate={isHovered ? {
          rotate: [0, -10, 10, -10, 0],
        } : { rotate: 0 }}
        transition={{ duration: 0.5 }}
      >
        <Icon size={size} style={{ color }} />
      </motion.div>
    </motion.div>
  );
};

export default AnimatedIcon;
